import { Component } from '@angular/core';
import { SecurityPermissionName } from '@app/core/models/permission';
import { SubNavBaseComponent } from '@app/menu/components/sub-nav-base-component';

@Component({
  selector: 'portal-enterprise-call-center-sub-nav',
  templateUrl: './enterprise-call-center-sub-nav.component.html',
  standalone: false,
})
export class EnterpriseCallCenterSubNavComponent extends SubNavBaseComponent {
  public Permission = SecurityPermissionName;
}
